import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ProfileCorrectionsLayer from "../components/ProfileCorrectionsLayer";

const ProfileCorrectionsPage = () => {
    return (
        <MasterLayout>
            <ProfileCorrectionsLayer />
        </MasterLayout>
    );
};

export default ProfileCorrectionsPage;
